import { cx } from "../../lib/index.js";
import { createButtonComponent } from "../Button.js";
export function createChatPromptSuggestionsComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function ChatPromptSuggestions(userProps) {
    var _userProps$suggestion = userProps.suggestions,
      suggestions = _userProps$suggestion === void 0 ? [] : _userProps$suggestion,
      onSuggestionClick = userProps.onSuggestionClick,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames;
    if (suggestions.length === 0) {
      return null;
    }
    return createElement("div", {
      className: cx('ais-ChatPromptSuggestions', classNames.root)
    }, suggestions.map(function (suggestion, index) {
      return createElement(Button, {
        key: index,
        size: "sm",
        variant: "primary",
        className: cx('ais-ChatPromptSuggestions-suggestion', classNames.suggestion),
        onClick: function onClick() {
          return onSuggestionClick(suggestion);
        }
      }, suggestion);
    }));
  };
}